import { createSelector } from 'reselect';

const getVehicleCacheState = (state) => state.vehicleCache || {};
const isValidCacheEntry = (entry) => {
  if (!entry || !entry.timestamp || !entry.ttl) {
    return false;
  }

  const now = Date.now();
  return now - entry.timestamp < entry.ttl;
};

const createCacheSelector = (cacheType) => {
  return createSelector(
    [getVehicleCacheState, (state, cacheKey) => cacheKey],
    (vehicleCache, cacheKey) => {
      const cacheSection = vehicleCache[cacheType];
      if (!cacheSection) return null;

      const entry = cacheSection[cacheKey];

      if (!entry) return null;

      if (isValidCacheEntry(entry)) {
        return entry.data;
      }
      return null; // Expired
    }
  );
};

export const getCachedVehicleMakes = createCacheSelector('makes');
export const getCachedVehicleYears = createCacheSelector('years');
export const getCachedVehicleModels = createCacheSelector('models');
export const getCachedVehicleTrims = createCacheSelector('trims');
export const getCachedVehiclePrices = createCacheSelector('prices');
